import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import ChatInput from "./ChatInput";
import Message from "./message/Message";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import logoFav from "./../assets/logo-fav.png";
import Review from "./Review";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { CircularProgress, Stack } from "@mui/material";

const backendApp = process.env.REACT_APP_BACKEND_URL;

const loadingMessages = [
  "Analyzing your query...",
  "Finding the best answer...",
];

// Ratings are stored as text ("1" to "5"), so anything else is shown as-is without stars.
const formatStars = (rating) => {
  const value = Number(rating);
  if (!Number.isInteger(value) || value < 0 || value > 5) return "";
  return "★".repeat(value) + "☆".repeat(5 - value);
};

export default function ChatContainer({ currentChat, currentChatType }) {
  const [searchParams] = useSearchParams();
  const isAdminView = searchParams.get("user") === "admin";
  const [threadReviews, setThreadReviews] = useState([]);
  const [reviewStatus, setReviewStatus] = useState("loading");
  const scrollRef = useRef(null);
  function scrollToBottom() {
    const listContainer = document.getElementById("chat-messages");
    setTimeout(() => {
      if(listContainer){
        listContainer.scrollTop = listContainer.scrollHeight;
      }
    }, 1);
  }
  const onCreatNewThread = async () => {
    const sent = await axios.post(`${backendApp}/start`);
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("thread-id", sent.data.thread.id);
    window.history.pushState(null, "", "?" + searchParams.toString());
    localStorage.setItem("thread_id", sent.data.thread.id);
    window.location.reload();
  };

  useEffect(() => {
    const loadConversation = async () => {
      try {
        const threadId = searchParams.get("thread-id");

        if (threadId) {
          const res = await axios.get(`${backendApp}/messages/${threadId}`);
          setMessages(res.data.messages.reverse());
        } else {
          const threadId = localStorage.getItem("thread-id");
          if (threadId) {
            searchParams.set("thread-id", threadId);
            window.history.pushState(null, "", "?" + searchParams.toString());
            window.location.reload();
          } else {
            await onCreatNewThread();
          }
        }
        scrollToBottom();
      } catch (error) {
        console.error("Error loading conversation:", error);
      }
    };
    loadConversation();
  }, [searchParams]);

  useEffect(() => {
    const threadId = searchParams.get("thread-id");
    if (!isAdminView || !threadId) return;
    const loadReviews = async () => {
      const token = localStorage.getItem("auth-token");
      if (!token) {
        setReviewStatus("login");
        return;
      }
      setReviewStatus("loading");
      try {
        const res = await axios.get(`${backendApp}/reviews/${threadId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setThreadReviews(res.data.reviews);
        setReviewStatus("loaded");
      } catch (error) {
        console.error("Error loading rating:", error);
        setReviewStatus(error.response?.status === 401 ? "login" : "error");
      }
    };
    loadReviews();
  }, [searchParams, isAdminView]);
  const [messages, setMessages] = useState([]);
  const [sendMessageLoading, setSendMessageLoading] = useState(false);
   const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [loadingMessage, setLoadingMessage] = useState(loadingMessages[0]);
  const sendMessage = async (text) => {
    setMessages(prevMessages => [
      ...prevMessages,
      { role: "user", content: [{ text: { value: text } }] }
    ]);
    scrollToBottom();
  
    setSendMessageLoading(true);

    const interval = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => {
        const newIndex = (prevIndex + 1) % loadingMessages.length;
        setLoadingMessage(loadingMessages[newIndex]);
        if(newIndex == (loadingMessages.length - 1)){
          clearInterval(interval);
        }
        return newIndex;
      });
    }, 3000);
  
    try {
      const response = await axios.post(`${backendApp}/chat`, {
        threadId: searchParams.get("thread-id"),
        message: text,
      });
  
      const fullMessage = response.data.answere;
      let typingMessage = "";
      
      setMessages(prevMessages => [
        ...prevMessages,
        { role: "assistant", content: [{ text: { value: "" } }] } // Empty message for animation
      ]);
      scrollToBottom();

  
      let index = 0;
      const interval = setInterval(() => {
        typingMessage += fullMessage[index];
        setMessages(prevMessages => {
          let updatedMessages = [...prevMessages];
          updatedMessages[updatedMessages.length - 1] = { 
            role: "assistant", 
            content: [{ text: { value: typingMessage } }]
          };
          return updatedMessages;
        });
        scrollToBottom();
        
        index++;
        if (index === fullMessage.length) clearInterval(interval);
      }, 1); 
  
    } catch (error) {
      console.error("Error sending message:", error);
      setMessages(prevMessages => [
        ...prevMessages,
        {
          role: "assistant",
          content: [{ text: { value: error.response?.data?.answere || "Sorry, something went wrong. Please try again." } }]
        }
      ]);
      scrollToBottom();
    }
    setSendMessageLoading(false);
    setLoadingMessage(loadingMessages[0]);
    setCurrentMessageIndex(0);
    clearInterval(interval);
  };
  const endConversation = () => {
      setIsEndConversation(true)
  }

  const navigate = useNavigate();
  
  const closeWindow = () => {
    if(isEndConversation){
      setIsEndConversation(false)
      navigate('/')
    }
    window.parent.postMessage({ action: "closeIframe" }, "*");
  }

  const [isEndConversation, setIsEndConversation] = useState(false);
  return (
    <Container className="chat-container">
      <div className="chat-header" style={{ width: "100%" }}>
        <div className="user-details" style={{ width: "100%" }}>
          <div
            className="username"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                marginLeft: "1rem",
              }}
            >
              <img src={logoFav} className="logoFav"></img>
              <h3>GM Lighting</h3>
            </div>
            <div>
              {searchParams.get("user") !=='admin' ? 
                (messages.length > 0 && !isEndConversation ? (
                  <button
                    style={{
                      backgroundColor: "#87b048",
                      color: "white",
                      border: "none",
                      padding: "0.5rem",
                      borderRadius: "0.5rem",
                      cursor: "pointer",
                      marginRight: "1rem",
                      height: "40px",
                    }}
                    onClick={() => endConversation()}
                  >
                    End Conversation
                  </button>
                ) : (
                  <div
                    style={{
                      backgroundColor: "#87b048",
                      borderRadius: "0.5rem",
                      height: "30px",
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: "1rem",
                      width: '30px',
                      color: 'white',
                      cursor: 'pointer'
                    }}
                    onClick={() => closeWindow()}
                  >
                    <KeyboardArrowDownIcon />
                  </div>
                )): ''}
            </div>
          </div>
        </div>
      </div>
      {!isEndConversation ? (
        <>
          <div id="chat-messages">
          {isAdminView && (
            <div className="admin-rating">
              <strong>Customer rating: </strong>
              {reviewStatus === "loading" && "Loading..."}
              {reviewStatus === "login" && (
                <>
                  Log in to see it. <a href="/login">Log in</a>
                </>
              )}
              {reviewStatus === "error" && "Couldn't load the rating."}
              {reviewStatus === "loaded" && threadReviews.length === 0 && "No rating left for this conversation."}
              {reviewStatus === "loaded" &&
                threadReviews.map((review) => (
                  <div key={review._id} className="admin-rating-entry">
                    <span className="stars" aria-hidden="true">{formatStars(review.rating)}</span>
                    <span>{review.rating ? `${review.rating}/5` : "No stars given"}</span>
                    {review.review && <q>{review.review}</q>}
                    <span className="date">{new Date(review.createdAt).toLocaleString()}</span>
                  </div>
                ))}
            </div>
          )}
          {messages?.map((message) => {
            return (
                <div
                  ref={scrollRef}
                  key={message.id}
                  className={`message ${
                    message.role === "user" ? "sended" : "recieved"
                  }`}
                >
                  <div className="content">
                    <Message content={message?.content[0]?.text?.value} />
                  </div>
                </div>
              );
            })}
             {sendMessageLoading ? 
              <div
              ref={scrollRef}
              style={{display: 'flex', flexDirection: 'column', gap:8, justifyContent:'start', alignItems:"start"}}
              className={`message recieved`}
            >
              {/* <Stack direction="row" gap="6px" alignItems='center'>
                <CircularProgress size="20px" color="gray"/>
                <div style={{fontSize:'10px', color:'gray'}}>{loadingMessage}</div>
              </Stack> */}
              <div className="content">
                <Stack direction="row" gap="8px" alignItems='center'>
                  <Message content={'loaderX'} />
                  <div style={{fontSize:'11px', color:'gray'}}>{loadingMessage}</div>
                </Stack>
                {/* <Message content={'loaderX'} /> */}
              </div>
            </div> : ''}

          </div>
         
        
          {isAdminView ? (
            <div className="read-only-note">
              Read-only view. Messages can't be sent from the admin view.
            </div>
          ) : (
            <ChatInput
              sendMessageAPI={sendMessage}
              sendMessageLoading={sendMessageLoading}
            />
          )}
        </>
      ) : (
      <><Review threadId={searchParams.get("thread-id")} setIsEndConversation={setIsEndConversation}/></>
      )}
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  grid-template-rows: 10% 80% 10%;
  gap: 0.1rem;
  overflow: hidden;
  @media screen and (min-width: 720px) and (max-width: 1080px) {
    grid-template-rows: 15% 70% 15%;
  }
    .chat-header {
    display: flex;
    justify-content: space-between;casual
    align-items: center;
    padding: 0 2rem;
    .user-details {
      display: flex;
      align-items: center;
      gap: 1rem;
      .avatar {
        img {
          height: 3rem;
        }
      }
      .username {
        h3 {
          color: white;
        }
      }
    }
  }
  #chat-messages {
    padding: 1rem 2rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 0.2rem;
      &-thumb {
        background-color: #ffffff39;
        width: 0.1rem;
        border-radius: 1rem;
      }
    }
    #down-arrow{
      position: fixed;
      bottom: 120px;
      right: 40px;
      img{
        width: 50px;
      }
    }
    .chat-date{
      text-align: center;
      color: white;
    }
    .message {
      display: flex;
      align-items: center;
      .content {
        max-width: 40%;
        overflow-wrap: break-word;
        padding: 1rem;
        font-size: 1.1rem;
        border-radius: 1rem;
        color: #d1d1d1;
        @media screen and (min-width: 720px) and (max-width: 1080px) {
          max-width: 70%;
        }
      }
    }
    .sended {
      justify-content: flex-end;
      .content {
        background-color: #4f04ff21;
        img{
          display: block;
          width: 30px;
          float: right;
        }
      }
    }
    .recieved {
      justify-content: flex-start;
      .content {
        background-color: #9900ff20;
      }
    }
    .admin-rating {
      position: sticky;
      top: 0;
      z-index: 1;
      padding: 0.75rem 1rem;
      border-left: 4px solid #87b048;
      border-radius: 0.5rem;
      background-color: #f3f6ee;
      color: #131324;
      font-size: 0.9rem;
      a {
        color: #87b048;
        font-weight: 600;
      }
      .admin-rating-entry {
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        gap: 0.5rem;
        margin-top: 0.25rem;
      }
      .stars {
        color: #87b048;
        letter-spacing: 1px;
      }
      q {
        font-style: italic;
      }
      .date {
        color: #5b5b5b;
        font-size: 0.8rem;
      }
    }
  }
  .read-only-note {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 1rem;
    border-top: 1px solid #e0e0e0;
    color: #5b5b5b;
    font-size: 0.85rem;
    text-align: center;
  }
`;
